import React, { useEffect, useState } from 'react';
import {List, Skeleton, Divider } from 'antd';
import { _setAxios } from '../../../../../lib/Helper';

async function getIntegrationWa(integrationId) {
    if (!integrationId) {
        return []
    }
    return await _setAxios("whatsapp/phone-integration/" + integrationId, "GET", null).then(resp => {
        return resp
    })
}

const HeaderIntegrationModule = ({ integrationId }) => {

    const [loading, setLoading] = useState(true);
    const [header, setHeader] = useState();

    useEffect(() => {
        getIntegrationWa(integrationId).then(resp => {
            let data = resp.data.data
            setLoading(false)
            setHeader([{
                title: 'Service',
                description: data.whatsapp_service_name ? data.whatsapp_service_name : "-",
            },{
                title: 'Whatsapp nomor',
                description: data.wa_number ? data.wa_number : "-",
            }])

        })
    }, [integrationId]);

    return (
        <>
            <div className="site-layout-background" style={{ padding: 24 }}>
                {
                    !loading ?
                        <List
                            itemLayout="horizontal"
                            dataSource={header}
                            renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                        title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                    />
                                </List.Item>
                            )}
                        />
                        :
                        <Skeleton />
                }
            </div>

            <Divider />
        </>
    );
};
export default HeaderIntegrationModule;
